import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import "./index.css"

import { Button, DropDownField } from '../../helpers'

import PriceAndGeoMappings from './Components/PriceAndGeoMappings'

import { getVendorRateContracts } from '../../services/api/vendorRateContract'

import { raiseToast } from '../../services/redux/reducers/toast/toast'
import { fetchVendorRCCoverageTypes, fetchVendorRCTypes } from '../../services/redux/reducers/commonThunk'


const VendorRateContract = () => {

    const [visibleAddVendorRateContract, setVisibleAddVendorRateContract] = useState(false)

    const [selectedVendorRateContractId, setSelectedVendorRateContractId] = useState(null)
    const [vendorRateContracts, setVendorRateContracts] = useState([])

    const vendorRCTypes = useSelector(state => state.common.vendorRCTypes)
    const vendorRCCoverageTypes = useSelector(state => state.common.vendorRCCoverageTypes)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchVendorRCTypes())
        dispatch(fetchVendorRCCoverageTypes())
    }, [])

    useEffect(() => {
        getVendorRateContractsDetails()
    }, [])

    const getVendorRateContractsDetails = async () => {
        const vendorRateContractsRes = await getVendorRateContracts()
        // console.log("vendorRateContractsRes", vendorRateContractsRes)

        if (vendorRateContractsRes.failure){
            return dispatch(raiseToast({severity:'error', detail: vendorRateContractsRes.data.error, summary: 'Vendor Rate Contracts were not fetched.', life: 3000}))
        }

        setVendorRateContracts(vendorRateContractsRes)
    }

    return (
        <div className="requirement-layout flex flex-column">
            <div className="flex flex-column md:flex-row justify-content-between">
                <h4 className="mx-2 my-1 md:m-2">VENDOR RATE CONTRACT</h4>
                <div className="flex gap-2 justify-content-end mb-2">
                    <Button icon="" className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="New RC Catalogue" onClick={() => {setSelectedVendorRateContractId(null); setVisibleAddVendorRateContract(true)}}/>
                </div>
            </div>
            <div className='flex flex-column md:flex-row'>
                <div className="flex flex-column col-12 md:col-2 pr-0 md:pr-2">
                    <DropDownField name="vendorRateContractId" labelText="Vendor RC Catalogue" options={vendorRateContracts} optionLabel="catalogueName" optionValue="vendorRateContractId" value={selectedVendorRateContractId} onChange={(event) => setSelectedVendorRateContractId(event.target.value)}/>
                </div>
                <div className="flex mt-1 justify-content-end md:justify-content-center md:mt-4 md:ml-2">
                    <Button className="" style={{height: '32px'}} label="VIEW" disabled={!selectedVendorRateContractId} onClick={() => {setVisibleAddVendorRateContract(true); setSelectedVendorRateContractId(null)}}/>
                </div>
            </div>
            <PriceAndGeoMappings
                vendorRateContractId={selectedVendorRateContractId}
                vendorRCTypes={vendorRCTypes}
                vendorRCCoverageTypes={vendorRCCoverageTypes}
                visibleAddVendorRateContract={visibleAddVendorRateContract}
                setVisibleAddVendorRateContract={setVisibleAddVendorRateContract}
            />
        </div>
    )
}

export default VendorRateContract